import React from 'react'

function Direction1() {
    return (
        <div className='direction'> 
            <h1>Directions!!!</h1>
            <h4>To test it out, download the expo application and enter this link:</h4>
            <ul>
                <li>Android: ' exp://u.expo.dev/update/5eebc198-996e-49de-912c-c389393c2ed9'  </li>
                <li> IOS: 'exp://u.expo.dev/update/f8b7e2bb-c5bf-476a-98bc-2150f19a94d1 '</li>
            </ul>
        </div>
    )
}

export default Direction1